import { useFetchWithRetry } from "../Utils/fetchWithRetry";
import { logError, logInfo } from "../Utils/loggers";

export const TicketValidationServices = () => {
    const { fetchWithRetry } = useFetchWithRetry();
 
    
    const validateChangeTicket = async (changeNumber) => {
     const apiEndpoint = process.env.REACT_APP_POSTMORTEM_API_ENDPOINT
      logInfo(
        "validateChangeTicket",
        "validating change number"
      );
      try {
        const url =
          apiEndpoint +
          `/validate-change?changeId=${changeNumber}`;
  
        const data = await fetchWithRetry(url);
        logInfo(
          "validateChangeTicket",
          "validated change number successfully"
        );
        // if (!response.ok) {
        //     throw new Error(`HTTP error! status: ${response}`);
        //   }
         
          logInfo(
            "validateChangeTicket",
            "validated change number successfully"
          );
          return data;
      } catch (error) {
        logError(
          "validateChangeTicket",
          "validateChangeTicket failed",
          error
        );
        throw error;
      }
    };

    const validateIncidentTicket = async (incidentNumber) => {
        const apiEndpoint = process.env.REACT_APP_POSTMORTEM_API_ENDPOINT
         logInfo(
           "validateIncidentTickett",
           "validating incident number"
         );
         try {
           const url =
             apiEndpoint +
             `/validate-incident?incidentId=${incidentNumber}`;
     
           const data = await fetchWithRetry(url);
           logInfo(
             "validateIncidentTicket",
             "validated incident number successfully"
           );
           // if (!response.ok) {
           //     throw new Error(`HTTP error! status: ${response}`);
           //   }
            
             logInfo(
               "validateIncidentTicket",
               "validated incident number successfully"
             );
             return data;
         } catch (error) {
           logError(
             "validateIncidentTicket",
             "validateIncidentTicket failed",
             error
           );
           throw error;
         }
       };

    return {
        validateChangeTicket,
        validateIncidentTicket
    }
}